$(window.document).ready(function(e){


$("#formIlTuoMutuoSzPreoccupazioni").on("change","#durata_mutuo",function(){
    var dataTasso = $("#durata_mutuo option:selected").attr("data-tasso");
    var tipo_tasso = $("#durata_mutuo option:selected").attr("data-tipo");
    var sDataTasso = '';
    if(dataTasso != "" && dataTasso != undefined) {
        sDataTasso = dataTasso+"%";
    }
    $("#tipo_tasso").val(tipo_tasso);
    $("#jsTasso").html(sDataTasso);
});

if($("#jsTasso").length > 0){
    var dataTasso = $("#durata_mutuo option:selected").attr("data-tasso");
    var sDataTasso = '';
    if(dataTasso != "" && dataTasso != undefined) {
        sDataTasso = dataTasso+"%";
    }
    $("#jsTasso").html(sDataTasso);
}

var nImmobilePrezzo;
$(document).on("click","#importoimmobile",function(){
    nImmobilePrezzo = $(this).val();
    $(this).val("");
});

$(document).on("focusout","#importoimmobile",function(){
    $(this).val(nImmobilePrezzo);
});

var nImportomutuo;
$(document).on("click","#importomutuo",function(){
    nImportomutuo = $(this).val();
    $(this).val("");
});

$(document).on("focusout","#importomutuo",function(){
    $(this).val(nImportomutuo);
});

$("#formIlTuoMutuoSzPreoccupazioni").on("keyup","#importomutuo",function(){
    var prezzo = $(this).val();
    if(prezzo.indexOf(".") > 0){
        prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
    }
    prezzo = parseInt(prezzo) || "";
    prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
    nImportomutuo = prezzo;
    $("#importomutuo").val(prezzo);
});

$("#formIlTuoMutuoSzPreoccupazioni").on("change","#importomutuo",function(){
    var prezzo = $(this).val();
    if(prezzo.indexOf(".") > 0){
        prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
    }
    // if(prezzo < 1000){
    //     prezzo = 1000;
    // }
    prezzo = parseInt(prezzo) || "";
    prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.');
    nImportomutuo = prezzo;
    $("#importomutuo").val(prezzo);
});

$("#formIlTuoMutuoSzPreoccupazioni").on("keyup","#importoimmobile",function(){
    var prezzo = $(this).val();
    if(prezzo.indexOf(".") > 0){
        prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
    }
    prezzo = parseInt(prezzo);
    prezzo = String(prezzo).replace(/(.)(?=(\d{3})+$)/g,'$1.')
    nImmobilePrezzo = prezzo;
    $("#importoimmobile").val(prezzo);
});


if ($("#formIlTuoMutuoSzPreoccupazioni").length > 0) {
    $("#formIlTuoMutuoSzPreoccupazioni").validate({
        ignore: [],
        focusInvalid: false,
        errorPlacement: function(error, element) {
            return true;
        },
        rules: {
            cognome: {
                required:true
            },
            email: {
                required: true,
                verifyemail: true
            }
        }
    });
}

if($("#formIlTuoMutuoSzPreoccupazioni_p1").length > 0){
        $("#formIlTuoMutuoSzPreoccupazioni_p1").validate({
        ignore: [],
        focusInvalid: false,
        rules: {
            nome: {
                required: true
            },
            cognome:{
                required: true
            },
            telefono: {
                required: true,
                numberTelefono: true
            }
        }
    });
}

$("#formIlTuoMutuoSzPreoccupazioni").on("click","#inviaIlTuoMutuoSzPreo",function(){
    if($("#formIlTuoMutuoSzPreoccupazioni").valid()) {
        $(this).prop("disabled",true);
        var dati = $("#formIlTuoMutuoSzPreoccupazioni").serialize();
        $.ajax({
            url: '/solicitud-hipoteca-confirmacion',
            type: 'POST',
            data: dati,
            dataType:'JSON',
            success:function(data) {         
                window.location.href=data.redirectUrl;
            }
        });
     }
     else{
         console.log("form not valid");
     }
});

$("#formIlTuoMutuoSzPreoccupazioni_p1").on("click","#inviaIlTuoMutuoSzPreo",function(){
    if($("#formIlTuoMutuoSzPreoccupazioni_p1").valid()){
        $("#formIlTuoMutuoSzPreoccupazioni_p1").submit();
    }
    else{
        console.log("form not valid");
    }
});

$("#llama, #whatsapp").on('click',function(e){
    if($("#llama").prop( "href" ) =="" ){

        $("#llama").prop( "href","tel:"+$("#llama").data('tel') );
        $("#llama span").html($("#llama").data('tel'));

        if($("#whatsapp").length > 0){
            $("#whatsapp").prop( "href","https://api.whatsapp.com/send?phone=34:"+$("#whatsapp").data('tel') );
            $("#whatsapp span").html($("#whatsapp").data('tel'));
    
        }
        if(dataLayer){
            dataLayer.push({
                event: 'telephoneClick',
                agency: $("#llama").data('agency'),
            })
        }
        e.preventDefault();
        e.stopPropagation();

    }

})


  
function createMap($id) {

    var latitudine = $("#"+$id).data("latitudine"),
        longitudine = $("#"+$id).data("longitudine"),
        rete = $("#"+$id).data("rete");
    var myCenter = new google.maps.LatLng(latitudine, longitudine);
    var myCenterMap = new google.maps.LatLng(latitudine, longitudine);
    var mapCanvas = document.getElementById($id);

    var iconDovesei = '/images/ico/marker.png';
    if (rete == 'epi') {
        iconDovesei = '/images/ico/markerEpica.png';
    }

    var marIcon = new google.maps.MarkerImage(
        iconDovesei,
        null,
        null,
        null,
    );

    var marker;

    var mapOptions = {
        center: myCenterMap,
        zoom: 15
    };

    map = new google.maps.Map(mapCanvas, mapOptions);
    var marker = new google.maps.Marker({
        position: myCenter,
        icon: marIcon,
        map: map,
        animation: google.maps.Animation.DROP
    });

    //infoWindow = new google.maps.InfoWindow();



}
});